import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import EmptyState from '../empty-state';
import { isWithinTradingHours } from '../../../../../helpers/utils';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import './sectoral-movements-futures-external.m.css';

const SectoralMovementsFuturesExternal = () => {
  const [tableData, setTableData] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);
  const tradingHolidays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'trading_holidays'], []),
  );
  const specialTradingDays = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'special_trading_days'], {}),
  );

  const getSectoralMovementsData = async () => {
    const response = await fetch(`/foapi/future/getSectoralMovement`);
    return response.json();
  };

  const resultSectoralMovementsData = useQuery(
    'getSectoralMovementsData',
    () => getSectoralMovementsData(),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setTableData(data?.data);
      },
      enabled: initialLoading || isWithinTradingHours(tradingHolidays, specialTradingDays),
    },
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (resultSectoralMovementsData?.isSuccess) {
      setTableData(resultSectoralMovementsData?.data?.data);
    }
  }, []);

  const getUpDownRatio = (firstValue, secondValue) => {
    return (firstValue / secondValue) * 100;
  };

  return (
    <React.Fragment>
      {initialLoading ? (
        <div styleName="initial-loading-container"></div>
      ) : (
        <div styleName="overall-container">
          <div>
            <span styleName="header-title">SECTORAL MOVEMENTS</span>
          </div>
          {tableData && tableData?.length !== 0 ? (
            <div styleName="table-container">
              <table>
                <thead>
                  <tr styleName="first-header-row">
                    <th colSpan={4} styleName="line-seperator"></th>
                    <th colSpan={4} styleName="line-seperator">
                      PRICE MOVEMENT
                    </th>
                    <th colSpan={4} styleName="line-seperator">
                      OPEN INTEREST MOVEMENT
                    </th>
                    <th colSpan={4}>VOLUME MOVEMENT</th>
                  </tr>
                  <tr styleName="first-header-row">
                    <th colSpan={4} styleName="line-seperator"></th>
                    <th colSpan={4} styleName="line-seperator">
                      PRICE MOVEMENT
                    </th>
                    <th colSpan={4} styleName="line-seperator">
                      OPEN INTEREST MOVEMENT
                    </th>
                    <th colSpan={4}>VOLUME MOVEMENT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr styleName="second-header">
                    <td colSpan={2} styleName="left-elements">
                      Sectors
                    </td>
                    <td colSpan={2} styleName="line-seperator">
                      Futures
                    </td>
                    <td colSpan={3}>Changes</td>
                    <td styleName="line-seperator">Down vs UP</td>
                    <td colSpan={3}>Changes</td>
                    <td styleName="line-seperator">Down vs UP</td>
                    <td colSpan={3}>Changes</td>
                    <td>Down vs UP</td>
                  </tr>
                  <tr styleName="second-header">
                    <td colSpan={2} styleName="left-elements">
                      Sectors
                    </td>
                    <td colSpan={2} styleName="line-seperator">
                      Futures
                    </td>
                    <td colSpan={3}>Changes</td>
                    <td styleName="line-seperator">Down vs UP</td>
                    <td colSpan={3}>Changes</td>
                    <td styleName="line-seperator">Down vs UP</td>
                    <td colSpan={3}>Changes</td>
                    <td>Down vs UP</td>
                  </tr>

                  {tableData?.map((dataPoint, index) => (
                    <tr key={index} styleName="data-rows">
                      <td colSpan={2} styleName="name left-elements">
                        {dataPoint?.sector}
                      </td>
                      <td colSpan={2} styleName="line-seperator neutral-data-value">
                        {dataPoint['number-of-futures']}
                      </td>
                      <td styleName="positive-value">{dataPoint['price-up']}</td>
                      <td styleName="negative-value">{dataPoint['price-down']}</td>
                      <td styleName="neutral-data-value ">{dataPoint['price-unchanged']}</td>
                      <td styleName="line-seperator central">
                        {Math.abs(dataPoint['price-up'] - dataPoint['price-down']) === 0 ? (
                          <span styleName="no-bar"></span>
                        ) : (
                          <div styleName="bar-container">
                            <span
                              styleName="bar-negative"
                              style={{
                                width: `${getUpDownRatio(
                                  dataPoint['price-down'],
                                  dataPoint['price-down'] + dataPoint['price-up'],
                                )}%`,
                              }}
                            ></span>
                            <span
                              styleName="bar-positive"
                              style={{
                                width: `${getUpDownRatio(
                                  dataPoint['price-up'],
                                  dataPoint['price-down'] + dataPoint['price-up'],
                                )}%`,
                              }}
                            ></span>
                          </div>
                        )}
                      </td>
                      <td styleName="positive-value">{dataPoint['open-interest-up']}</td>
                      <td styleName="negative-value">{dataPoint['open-interest-down']}</td>
                      <td styleName="neutral-data-value">{dataPoint['open-interest-unchanged']}</td>
                      <td styleName="line-seperator">
                        {Math.abs(
                          dataPoint['open-interest-up'] - dataPoint['open-interest-down'],
                        ) === 0 ? (
                          <span styleName="no-bar"></span>
                        ) : (
                          <div styleName="bar-container">
                            <span
                              styleName="bar-negative"
                              style={{
                                width: `${getUpDownRatio(
                                  dataPoint['open-interest-down'],
                                  dataPoint['open-interest-down'] + dataPoint['open-interest-up'],
                                )}%`,
                              }}
                            ></span>
                            <span
                              styleName="bar-positive"
                              style={{
                                width: `${getUpDownRatio(
                                  dataPoint['open-interest-up'],
                                  dataPoint['open-interest-down'] + dataPoint['open-interest-up'],
                                )}%`,
                              }}
                            ></span>
                          </div>
                        )}
                      </td>
                      <td styleName="positive-value">{dataPoint['volume-up']}</td>
                      <td styleName="negative-value">{dataPoint['volume-down']}</td>
                      <td styleName="neutral-data-value">{dataPoint['volume-unchanged']}</td>
                      <td>
                        {Math.abs(dataPoint['volume-up'] - dataPoint['volume-down']) === 0 ? (
                          <span styleName="no-bar"></span>
                        ) : (
                          <div styleName="bar-container">
                            <span
                              styleName="bar-negative"
                              style={{
                                width: `${getUpDownRatio(
                                  dataPoint['volume-down'],
                                  dataPoint['volume-down'] + dataPoint['volume-up'],
                                )}%`,
                              }}
                            ></span>
                            <span
                              styleName="bar-positive"
                              style={{
                                width: `${getUpDownRatio(
                                  dataPoint['volume-up'],
                                  dataPoint['volume-down'] + dataPoint['volume-up'],
                                )}%`,
                              }}
                            ></span>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div styleName="no-data-container-ext">
              <div styleName="no-data-container-int">
                <EmptyState />
              </div>
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default SectoralMovementsFuturesExternal;
